import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import CardsList from "@/components/CardsList";

import {StaffAPI} from "@/api/staff";

import AddIcon from "@mui/icons-material/Add";

import {ERROR_OPERATION} from "@/utils/constants";

import "./index.scss";

function ManagerStaffsPage(props) {
	const {handleNotification} = props;
	const navigate = useNavigate();
	const {t} = useTranslation();

	const seasonId = useSelector((state) => state?.season?.id);

	const [loading, setLoading] = useState(false);
	const [staffs, setStaffs] = useState([]);
	const [filtersData, setFiltersData] = useState(
		JSON.parse(sessionStorage.getItem("manager_staffs_filters")) || {},
	);

	const filters = [
		{
			key: "name",
			label: t("name"),
			value: filtersData?.name,
			setValue: (value) => {
				sessionStorage.setItem(
					"manager_staffs_filters",
					JSON.stringify({name: value}),
				);
				setFiltersData({...filtersData, name: value});
			},
		},
	];

	const getStaffRoleOrder = (role) => {
		let order = 0;
		switch (role) {
			case "Head Youth Sector":
				order = 1;
				break;
			case "Coordinator Base Activity":
				order = 2;
				break;
			case "Head Coach":
				order = 3;
				break;
			case "Second Coach":
				order = 4;
				break;
			case "Goalkeeper Coach":
				order = 5;
				break;
			case "Head of Performance":
				order = 6;
				break;
			case "Head of physiotherapist":
				order = 7;
				break;
			default:
				order = 8;
				break;
		}

		return order;
	};

	const getStaffs = async () => {
		setLoading(true);
		try {
			const response = await StaffAPI.list({
				...filtersData,
				prospect: false,
				seasonId,
			});
			setStaffs(
				response
					.filter((s) => s.rosters?.length)
					?.map((s) => {
						s.order = getStaffRoleOrder(s.role);
						return s;
					})
					?.sort((a, b) => {
						const byOrder = (a.order ?? Infinity) - (b.order ?? Infinity);
						if (byOrder !== 0) return byOrder;
						const aLast = (a.lastName ?? "").toString();
						const bLast = (b.lastName ?? "").toString();
						return aLast.localeCompare(bLast, "it", {sensitivity: "base"});
					}),
			);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			getStaffs();
		}, 500);

		return () => clearTimeout(delayDebounceFn);
	}, [filtersData]);

	const getListConfiguration = () => {
		return {
			data: staffs,
			onClick: (staff) => navigate("/manager/staffs/" + staff.id),
		};
	};

	const mainActions = [
		{
			icon: <AddIcon />,
			title: "Aggiungi staff",
			onClick: () => navigate("/manager/staffs/new"),
		},
	];

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs actions={<MainActions actions={mainActions} />} />
			<CardsList
				breadcrumbs
				filtersData={filters}
				type="staff"
				listConfiguration={getListConfiguration()}
			/>
		</Page>
	);
}

export default ManagerStaffsPage;
